import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  TextContainer,
  Toast,
  Checkbox,
  FormLayout,
  ChoiceList,
  Filters,
  TextField,
  Badge,
} from "@shopify/polaris";
import axios from "../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../Assets/Images/emptyList.svg";
import Pagination from "@material-ui/lab/Pagination";
import { HexColorPicker } from "react-colorful";
import validator from "validator";
import { accessSettings } from "../Helpers";

const Bookmarks = () => {
  const addEditState = useRef("");
  const perPage = 200;
  const [ts, setTs] = useState("");
  const [isListEmpty, setIsListEmpty] = useState(false);
  const [items, setItems] = useState([]);
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const handleAddBookmark = () => {
    addEditState.current = "add-bookmark";
    setBookmarkNameValue("");
    setBookmarkLinkValue("");
    setActiveAddEdit(true);
  };
  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    // {
    //   key: "availability",
    //   label: "Filter by",
    //   filter: (
    //     <ChoiceList
    //       title="Filter by"
    //       titleHidden
    //       choices={[{ label: "Name", value: "name" }]}
    //       selected={availability || []}
    //       onChange={handleAvailabilityChange}
    //     />
    //   ),
    //   shortcut: true,
    // },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = isLoading ? <Loading /> : null;
  const emtyState = isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <img src={emptyListImage}></img>
      </div>
      <div className="mb-3">
        <Text variant="headingLg" as="h5" color="subdued">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  useEffect(() => {
    getData();
  }, [ts, availability, queryValue]);
  const getData = () => {
    axios
      .get(
        `/bookmarks?per_page=${perPage}&page=${refBoolPage.current ? page : 1}${
          queryValue
            ? `&filter[${
                availability === "" ? "name" : availability
              }]=${queryValue}`
            : ""
        }`
      )
      .then((result) => {
        !result.data.data.length ? setIsListEmpty(true) : setIsListEmpty(false);
        // console.log(result.data.data);
        result?.data?.data &&
          setItems(
            result.data.data.map((item, index) => [
              <div className="row_click2">{item?.name && item.name}</div>,
              <div className="row_click2">{item?.url && item.url}</div>,
              <div className="me-3">
                <ButtonGroup>
                  <Button onClick={() => handleEdit(item)}>Edit</Button>
                  <Button destructive onClick={() => handleDelete(item.id)}>
                    Delete
                  </Button>
                </ButtonGroup>
              </div>,
            ])
          );
        setIsLoading(false);
      })
      .catch(function (error) {
        if (error.response) {
        }
      });
  };

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This bookmark has been successfully deleted"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const clickedBookmark = useRef(null);
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    clickedBookmark.current = id;
    setActiveDelete(true);
  };
  const handleEdit = (item) => {
    addEditState.current = "edit-bookmark";
    clickedBookmark.current = item;
    setBookmarkNameValue(item.name ? item.name : "");
    setBookmarkLinkValue(item.url ? item.url : "");
    setBookmarkColorValue(item.color ? item.color : "");
    setActiveAddEdit(true);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    const form_data = new FormData();
    axios
      .delete(`/bookmarks/${clickedBookmark.current}`)
      .then((result) => {
        setToastContent("This bookmark has been successfully deleted");
        toggleActive();
        setIsSaving(false);
        setActiveDelete(!activeDelete);
        setTs(+new Date());
        window.location.reload(false);
      })
      .catch((err) => console.log(err));
  };
  const [bookmarkNameValue, setBookmarkNameValue] = useState("");
  const handleChangeBookmarkName = (value) => {
    setBookmarkNameValue(value);
    setBookmarkNameError("");
  };
  const [bookmarkNameError, setBookmarkNameError] = useState("");
  const [bookmarkLinkValue, setBookmarkLinkValue] = useState("");
  const handleChangeBookmarkLink = (value) => {
    setBookmarkLinkValue(value);
    setBookmarkLinkError("");
  };
  const [bookmarkLinkError, setBookmarkLinkError] = useState("");
  const [bookmarkColorValue, setBookmarkColorValue] = useState("c1c1c1");
  const handleChangeBookmarkColor = (value) => {
    setBookmarkColorValue(value);
  };
  const [activeAddEdit, setActiveAddEdit] = useState(false);
  const handleChangeModalAddEdit = useCallback((activeAddEdit) => {
    setActiveAddEdit(!activeAddEdit);
    setIsSaving(false);
  }, []);
  const handleSubmitAddEdit = () => {
    const urlPattern = /^(http[s]?:\/\/)(www\.)?[^\s$.?#].[^\s]*$/;
    if (
      !bookmarkNameValue ||
      !bookmarkLinkValue ||
      (bookmarkLinkValue && !urlPattern.test(bookmarkLinkValue))
    ) {
      !bookmarkNameValue && setBookmarkNameError("This field is required");
      !bookmarkLinkValue && setBookmarkLinkError("This field is required");
      bookmarkLinkValue &&
        !urlPattern.test(bookmarkLinkValue) &&
        setBookmarkLinkError("Please enter a valid url");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      form_data.append("name", bookmarkNameValue);
      form_data.append("url", bookmarkLinkValue);
      form_data.append("color", bookmarkColorValue);
      addEditState.current === "edit-bookmark" &&
        form_data.append("_method", "PATCH");
      let url =
        addEditState.current === "add-bookmark"
          ? `/bookmarks`
          : `/bookmarks/${clickedBookmark.current.id}`;
      axios
        .post(url, form_data)
        .then((result) => {
          setToastContent(
            addEditState.current === "add-bookmark"
              ? `This bookmark has been successfully added`
              : "Changes have been saved successfully"
          );
          toggleActive();
          setIsSaving(false);
          setActiveAddEdit(false);
          setTs(+new Date());
          window.location.reload(false);
        })
        .catch((err) => console.log(err));
    }
  };
  return (
    accessSettings() && (
      <Page
        title="Bookmarks"
        primaryAction={
          <Button variant="primary" onClick={handleAddBookmark}>
            Add Bookmark
          </Button>
        }
      >
        <Card padding="0">
          {loadingMarkup}
          <Filters
            queryValue={queryValue}
            filters={filters}
            appliedFilters={appliedFilters}
            onQueryChange={handleFiltersQueryChange}
            onQueryClear={handleQueryValueRemove}
            onClearAll={handleFiltersClearAll}
          />
          <DataTable
            columnContentTypes={["text", "text", "text", "text"]}
            headings={[
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Name
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                URL
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
            ]}
            rows={items}
            verticalAlign="middle"
            increasedTableDensity
          />
          {emtyState}
          {totalPages >= 2 && (
            <div
              style={{
                paddingTop: "10px",
                textAlign: "center",
                paddingBottom: "10px",
              }}
            >
              <Pagination
                count={totalPages}
                page={page}
                onChange={handleChangePage}
                size="large"
              />
            </div>
          )}
          {/* <Modal
          open={activeModal}
          onClose={handleChangeModal}
          title="Add Bookmark"
          primaryAction={{
            content: "Submit",
            onAction: handleSubmitModal,
            loading: isSaving,
          }}
          secondaryActions={[
            {
              content: "Cancel",
              onAction: handleChangeModal,
              loading: isSaving,
            },
          ]}
        >
          <Modal.Section>
            <FormLayout>
              <Select
                label="Bookmark"
                placeholder="Please select"
                options={countryList}
                onChange={handleSelectChangeBookmark}
                value={selectedBookmark}
                error={bookmarkError}
              />
            </FormLayout>
          </Modal.Section>
        </Modal> */}

          <Modal
            open={activeDelete}
            onClose={handleChangeModalDelete}
            title="Delete Bookmark"
            primaryAction={{
              content: "Yes",
              onAction: handleYesDelete,
              loading: isSaving,
            }}
            secondaryActions={[
              {
                content: "No",
                loading: isSaving,
                onAction: handleChangeModalDelete,
              },
            ]}
          >
            <Modal.Section>
              <TextContainer>
                <p>Are you sure you want to delete this bookmark?</p>
              </TextContainer>
            </Modal.Section>
          </Modal>

          <Modal
            open={activeAddEdit}
            onClose={handleChangeModalAddEdit}
            title={`${
              addEditState.current === "add-bookmark" ? "Add" : "Edit"
            } Bookmark`}
            primaryAction={{
              content: "Submit",
              onAction: handleSubmitAddEdit,
              loading: isSaving,
            }}
            secondaryActions={[
              {
                content: "Cancel",
                loading: isSaving,
                onAction: handleChangeModalAddEdit,
              },
            ]}
          >
            <Modal.Section>
              <FormLayout>
                <TextField
                  label="Name"
                  value={bookmarkNameValue}
                  onChange={handleChangeBookmarkName}
                  error={bookmarkNameError}
                />
                <TextField
                  label="URL"
                  value={bookmarkLinkValue}
                  onChange={handleChangeBookmarkLink}
                  error={bookmarkLinkError}
                />
                <TextField
                  label="Color"
                  value={bookmarkColorValue}
                  onChange={handleChangeBookmarkColor}
                />
                <HexColorPicker
                  color={bookmarkColorValue}
                  onChange={handleChangeBookmarkColor}
                />
              </FormLayout>
            </Modal.Section>
          </Modal>
          {toastMarkup}
        </Card>
      </Page>
    )
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      // case "productType":
      //   return value.join(", ");
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
};

export default Bookmarks;
